/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';
import type { SigningProgressSummaryViewModel } from './SigningProgressSummaryViewModel';
import {
    SigningProgressSummaryViewModelFromJSON,
    SigningProgressSummaryViewModelFromJSONTyped,
    SigningProgressSummaryViewModelToJSON,
} from './SigningProgressSummaryViewModel';

/**
 * 
 * @export
 * @interface ResultOfSigningProgressSummaryViewModel
 */
export interface ResultOfSigningProgressSummaryViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfSigningProgressSummaryViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfSigningProgressSummaryViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfSigningProgressSummaryViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfSigningProgressSummaryViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfSigningProgressSummaryViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfSigningProgressSummaryViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfSigningProgressSummaryViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {SigningProgressSummaryViewModel}
     * @memberof ResultOfSigningProgressSummaryViewModel
     */
    data?: SigningProgressSummaryViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfSigningProgressSummaryViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfSigningProgressSummaryViewModel interface.
 */
export function instanceOfResultOfSigningProgressSummaryViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfSigningProgressSummaryViewModelFromJSON(json: any): ResultOfSigningProgressSummaryViewModel {
    return ResultOfSigningProgressSummaryViewModelFromJSONTyped(json, false);
}

export function ResultOfSigningProgressSummaryViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfSigningProgressSummaryViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : SigningProgressSummaryViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfSigningProgressSummaryViewModelToJSON(value?: ResultOfSigningProgressSummaryViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': SigningProgressSummaryViewModelToJSON(value.data),
        'Count': value.count,
    };
}

